import * as t from "io-ts";
import {
  createDriverSessionTypes,
  createStopDocumentTypes,
} from "dora-contracts";

export const { addEventT } = createDriverSessionTypes({
  decimal: t.string,
  date: t.string,
  dateTime: t.string,
});

const { stopDocumentT } = createStopDocumentTypes({ dateTime: t.string });

export type StopDocument = t.TypeOf<typeof stopDocumentT>;
export const documentsT = t.array(stopDocumentT);

export const { addFileReferenceWithTrailerT, deleteFileReferenceT } =
  createDriverSessionTypes({
    decimal: t.string,
    date: t.string,
    dateTime: t.string,
  });

